import { ApiService, type ApiRequestConfig } from "./api.service";
import type { components } from "@/types/api.generated";

/** What the hover card on a comment link shows (NG-3273). `unavailable` is a
 *  normal answer: the page needs a sign-in, failed, or has no title. */
export type LinkPreview = components["schemas"]["LinkPreview"];

/** Reads a link's title, description and site name. The server fetches the
 *  page, so hovering a comment never makes the viewer's browser contact the
 *  linked site. `config` carries a query's abort signal and timeout
 *  (`app/queries/link-previews.ts`). */
export class LinkPreviewService extends ApiService {
  async fetchPreview(slug: string, url: string, config?: ApiRequestConfig): Promise<LinkPreview> {
    return this.get<LinkPreview>(`/api/workspaces/${slug}/link-preview/`, {
      ...config,
      params: { url },
    });
  }
}
